import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './CAMErrorComponent.css';

const cx = classNames.bind(styles);

// Styling
const camErrorWrapperStyle = dt(['flex', 'justify-center', 'p-8', 'text-black']);
const errorSectionStyle = dt(['flex', 'flex-col', 'items-center']);
const errorMessageTitleStyle = dt(['leading-[1.33]', 'font-open-sans-bold', 'mb-6']);
const errorMessageStyle = dt(['leading-tight']);
const refreshButtonStyle = dt(['lg:!w-[300px]']);
// Styling

const CAMErrorComponent = ({
    type,
    errorDetails,
    hideRetryButton,
    onRetry,
    classes,
    buttonTitle,
    buttonType,
}) => (
    <div
        className={`${cx(
            'cam-error-wrapper',
            camErrorWrapperStyle,
            { 'page-level': type === 'page-level' },
            classes.wrapper
        )} ${dt([type === 'page-level' && 'min-h-[500px]'])}`}
    >
        <div className={cx('error-section', errorSectionStyle)}>
            {errorDetails.title && (
                <h2 className={cx('error-message-title', errorMessageTitleStyle)}>
                    {errorDetails.title}
                </h2>
            )}
            {errorDetails.message && (
                <p className={cx('error-message', errorMessageStyle)}>{errorDetails.message}</p>
            )}
            <br />
            {!hideRetryButton && (
                <Button
                    size="Lg"
                    buttonType={buttonType}
                    className={cx('refresh-button', refreshButtonStyle, classes.button)}
                    onClick={onRetry}
                >
                    {buttonTitle}
                </Button>
            )}
        </div>
    </div>
);

CAMErrorComponent.defaultProps = {
    type: 'page-level',
    hideRetryButton: false,
    errorDetails: {},
    onRetry: () => {
        window.location.reload();
    },
    classes: {
        wrapper: '',
        button: '',
    },
    buttonTitle: 'Refresh Page',
    buttonType: 'Secondary',
};

CAMErrorComponent.propTypes = {
    type: PropTypes.string,
    hideRetryButton: PropTypes.bool,
    errorDetails: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string,
    }),
    onRetry: PropTypes.func,
    classes: PropTypes.objectOf(PropTypes.object),
    buttonTitle: PropTypes.string,
    buttonType: PropTypes.string,
};

export default CAMErrorComponent;
